var _style, _path, _polygon, _path2, _polygon2, _polygon3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon4, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQwant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#path25_00000136379769441532332590000012777325351046780589_);}\r\n\t.st1{fill:#0A92EF;}\r\n\t.st2{fill:url(#polygon34_00000087370816912694447170000008783396982723383706_);}\r\n\t.st3{fill:#FFAA64;}\r\n\t.st4{fill:#0E9F9D;}\r\n\t.st5{fill:#2EC75B;}\r\n\t.st6{fill:#0ABFFF;}\r\n\t.st7{fill:#FF2B2A;}\r\n\t.st8{fill:#E60000;}\r\n\t.st9{fill:#FF2C1D;}\r\n\t.st10{fill:#FF5429;}\r\n\t.st11{fill:#FF8F2B;}\r\n\t.st12{fill:#B20070;}\r\n\t.st13{fill:#B9E239;}\r\n\t.st14{fill:#E4F445;}\r\n\t.st15{fill:#7CED91;}\r\n\t.st16{fill:#0F8791;}\r\n\t.st17{fill:#18D1C3;}\r\n\t.st18{fill:#47D6E5;}\r\n\t.st19{fill:#1B7EEA;}\r\n\t.st20{fill:#2AD3FF;}\r\n\t.st21{fill:url(#path81_00000108275217166446087380000012413956085413602201_);}\r\n\t.st22{fill:url(#path88_00000114075003854350133480000003567066312795972030_);}\r\n\t.st23{fill:#CD2B90;}\r\n\t.st24{fill:#0E799A;}\r\n\t.st25{fill:#FAFB3E;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path25_00000172413891842954818350000005866932105801832886_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.15,
    y1: 93.95,
    x2: 403.55,
    y2: 93.95,
    gradientTransform: "matrix(1 0 0 -1 -238.8 159.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDD24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4EF25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    style: {
      fill: "url(#path25_00000172413891842954818350000005866932105801832886_)"
    },
    d: " M151,68.3l13.8-21.1L111,31.5c-15.1,5-28.9,13.1-40.7,23.4L86.1,100c14.2-19.3,36.7-31.8,62.1-31.8C149.1,68.1,150,68.1,151,68.3 L151,68.3z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path27",
    className: "st1",
    d: "M249.8,223.6l-18.1-15l-40.1,6c-1.6,1.1-3.3,2.2-5.1,3.2l38,36.1 l21.4,18.9l25.6-30L249.8,223.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "polygon34_00000076593475389460523000000012542530002533471629_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.2681,
    y1: 88.1648,
    x2: 500.2619,
    y2: 29.9282,
    gradientTransform: "matrix(1 0 0 -1 -238.8 159.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAA64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF3264"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon34",
    style: {
      fill: "url(#polygon34_00000076593475389460523000000012542530002533471629_)"
    },
    points: "245.6,100.4  205.6,93.9 207.2,62.2 "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon36",
    className: "st3",
    points: "245.6,100.4 205.6,93.9 207.2,62.2 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "st4",
    d: "M205.7,94.1c4.4,4.9,8.2,10.5,11.3,16.4l35.4,51.4l-6.4-61.6 l-40.5-6.4L205.7,94.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon40",
    className: "st5",
    points: "245.6,100.4 205.6,93.9 207.2,62.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon42",
    className: "st6",
    points: "231.7,208.6 237.2,247.6 271.5,242.6 251.6,225 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "st7",
    d: "M97.6,234.6l10.8-18c-19.9-12.3-34-33.5-37.1-58.3L62.8,188 L97.6,234.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "st8",
    d: "M40.7,202c7.8,16.3,18.9,30.5,32.6,41.7l24.4-9.1l-35.2-47.1 L40.7,202z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "st9",
    d: "M41,202.6l21.8-14.6l-12.3-63.7l-16.2-13.7 c-3.7,11.8-5.7,24.5-5.7,37.6C28.5,167.6,33,186.1,41,202.6L41,202.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "st10",
    d: "M70.6,148.1c0-2.1,0.1-4.2,0.3-6.3l-20.4-17.5l12.3,63.7 l8.7-27.8C70.9,156.2,70.6,152.1,70.6,148.1L70.6,148.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path52",
    className: "st11",
    d: "M34.2,111l16.3,13.3l20.4,17.5c1.2-15.7,6.8-30.2,15.6-42.1 L74.9,67.4l-22.3,6.9C44.6,85.3,38.3,97.6,34.2,111z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path54",
    className: "st12",
    d: "M150.2,270.9v-41.3l0.2-1.5c-0.7,0-1.3,0-2,0 c-1.2,0-2.4,0-3.6-0.1l-47.2,6.7l-24.4,9.1c20.6,17,46.7,27.2,75.2,27.2C149,270.9,149.6,270.9,150.2,270.9L150.2,270.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path56",
    className: "st13",
    d: "M207.2,62.2l-42-15.7L151,68.3c21.6,0.7,41,10.5,54.7,25.8l0,0 L207.2,62.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path58",
    className: "st14",
    d: "M224.1,53c-15.6-13.1-35.4-22-56.2-25.7l-3.7,20l43.3,15.3 L224.1,53z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path60",
    className: "st15",
    d: "M224,52.9l-16.8,9.3l38.9,38.8l11.5-3.4 C249.9,80.1,238.2,64.8,224,52.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path64",
    className: "st16",
    d: "M226.2,148.1c0,16.5-4.9,31.9-13.3,44.6l39.1-31.3l-35.3-51.7 C222.7,121.1,226.2,134.2,226.2,148.1L226.2,148.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path68",
    className: "st17",
    d: "M245.6,100.4l6.4,61l16.2-7.4c0.1-2.5,0-3.4,0-5.9 c0-18.1-3.9-35.3-10.7-50.8L245.6,100.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path70",
    className: "st18",
    d: "M252,161.4l-20.3,47.2l17.3,14.3l0,0l-3.3-2.9l0,0 c13.2-18.7,21.4-41.4,22.5-66L252,161.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path72",
    className: "st19",
    d: "M237.2,247.6L187,217.5c-0.2,0.1-0.4,0.3-0.6,0.4l38,36.1 l21.4,18.9l1.4-1.6L237.2,247.6z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon74",
    className: "st20",
    points: "247.2,271.1 271.5,242.6 237.2,247.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path81_00000091694131193489845170000015424538988442600613_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.6046,
    y1: -120.7766,
    x2: 322.7567,
    y2: 219.3092,
    gradientTransform: "matrix(1 0 0 -1 -238.8 159.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6D19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBF124"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    style: {
      fill: "url(#path81_00000091694131193489845170000015424538988442600613_)"
    },
    d: " M29.2,134.7l21.2-10.5l24.4-56.9l-4.4-12.4C48,74.6,32.7,102.8,29.2,134.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path88_00000065072261406835421220000011433459015215425707_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.354,
    y1: 70.625,
    x2: 384.9179,
    y2: 92.3864,
    gradientTransform: "matrix(1 0 0 -1 -238.8 159.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDCE25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "url(#path88_00000065072261406835421220000011433459015215425707_)"
    },
    d: " M165,47.1L74.9,67.3l11.6,32.3l0,0c14.2-19.2,36.6-31.5,61.9-31.5c0.9,0,1.8,0,2.7,0.1l0,0L165,47.1z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path90",
    className: "st23",
    d: "M106.4,215.4l-9.3,19.5l53.2,34.5v-39.8l0.2-1.5 c-0.7,0-1.3,0-2,0C132.9,228.1,118.5,223.4,106.4,215.4L106.4,215.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path92",
    className: "st24",
    d: "M231.7,208.6l20.3-47.2l-39.1,31.4 c-5.7,8.6-17.3,18.9-25.8,24.6L231.7,208.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path94",
    className: "st25",
    d: "M169.2,27.5c-6.8-1.2-13.8-1.9-20.9-1.9 c-13,0-25.5,2.1-37.2,6.1l53.6,15.8L169.2,27.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwant);
export default __webpack_public_path__ + "static/media/qwant.f54dcd57c201379beca4a0786f3cece1.svg";
export { ForwardRef as ReactComponent };